import { IconBaseProps } from "react-icons";
import * as BiIcons from "react-icons/bi";

interface TypesPropsIcon {
  readonly icon: keyof typeof BiIcons;
  readonly propsIcon?: IconBaseProps;
  readonly className: string;
}

export default function DynamicBiIcon({
  icon,
  propsIcon,
  className,
}: TypesPropsIcon) {
  const ElementIcon = BiIcons[icon];

  if (!ElementIcon) return <span className={className}>?</span>;

  return <ElementIcon {...propsIcon} className={className} />;
}
